import { render, staticRenderFns } from "./labelBox.vue?vue&type=template&id=064f6259&scoped=true"
import script from "./labelBox.vue?vue&type=script&lang=js"
export * from "./labelBox.vue?vue&type=script&lang=js"
import style0 from "./labelBox.vue?vue&type=style&index=0&id=064f6259&prod&lang=scss"
import style1 from "./labelBox.vue?vue&type=style&index=1&id=064f6259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f6259",
  null
  
)

export default component.exports